import { ChangeDetectionStrategy, Component, computed, effect, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { convertToLocalDate } from '../../core';
import { BaseComponent, DatepickerComponent } from '../../shared';


/**
 * Component for patient Pin Site Care settings.
 */
@Component({
	selector: 'tsp-pin-site-care',
	imports: [
		FormsModule,
		DatepickerComponent
	],
	templateUrl: './pin-site-care.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PinSiteCareComponent extends BaseComponent {

	isEnabled = model<boolean>(false);
	firstDay = model<Date | null>();
	frequency = model<boolean[]>();
	isValid = output<boolean>();

	firstDayFormat = computed(() => convertToLocalDate(this.firstDay()!));

	readonly WEEKDAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
	private readonly _FREQUENCY = new Array(7).fill(false);

	private readonly checkIfValid = effect(() => this.isValid.emit(!this.isEnabled() || (!!this.firstDay() && !!this.frequency()?.includes(true))));

	/**
	 * Toggle Pin Site Care switch.
	 */
	toggle(): void {
		this.isEnabled.update(val => !val);
	}

	/**
	 * Toggle a week day for frequency.
	 */
	selectDay(index: number): void {
		const list = this.frequency() ?? [...this._FREQUENCY];
		list[index] = !list[index]
		this.frequency.set([...list]);
	}

	/**
	 * Select all week days for frequency.
	 */
	selectAllDays(): void {
		this.frequency.set(new Array(7).fill(true));
	}

}
